export const JSON_CONTENT_TYPE = 'application/json';
export const CONTENT_TYPE_HEADER = 'Content-Type';
export const REQUEST_TYPES_WITH_BODY = ['post', 'put', 'patch'];
export const CLIENT_ID_HEADER = 'x-client-id';
export const CORRELATION_ID_HEADER = 'x-correlation-id';
export const allowedKeysForTolkien = 'dgr_';



// WEBPACK FOOTER //
// ./src/common/network/networkConstants.js